import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Col, Card, Container } from "reactstrap";
import { TopCenter, directiontoaster } from "../../Constant";
import { toast } from "react-toastify";
import ModalLink from "../Modal/Modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { FaRegFilePdf, FaRegSave, FaRegEdit } from "react-icons/fa";
import { Breadcrumbs, Btn } from "../../AbstractElements";
import ModalDeleteBadge from "../ModalDeleteBadge/ModalBadge";
import ModelNewsFeed from "../ModalDeleteNewsFeed/ModalNewsFeed";
import "./styles.css";
import ModelDeleteNewsCategoryTag from "../ModelDeleteNewsCategoryTag/ModelDeleteNewsCategoryTag";
import ModalDelete from "../ModalDelete/Modal";

const ViewNewsCategoryTag = () => {
	const API_BASE_URL = window.appConfig.API_BASE_URL;
	const [data, setData] = useState([]);
	const [error, setError] = useState({ error: false, message: "" });
	const [pageLoaded, setPageLoaded] = useState(false);

	const fetchTags = () => {
		const source = axios.CancelToken.source();
		const authToken = sessionStorage.getItem("token");

		const tags = axios
			.get(`${API_BASE_URL}/NewsCategoryTag`, {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
				cancelToken: source.token,
			})
			.then((res) => {
				setData(res.data);
				setPageLoaded(true);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	useEffect(() => {
		fetchTags();
	}, []);

	const directiontoaster = (toastname) => {
		switch (toastname) {
			case "directionssuccessToast":
				toast.success("The tag was successfully deleted", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
			case "directionsdangerToast":
				toast.error("There was an error deleting the tag", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
		}
	};

	const deleteHandler = async (newsCategoryTagId) => {
		try {
			const response = await axios.delete(
				`${API_BASE_URL}/NewsCategoryTag/NewsCategoryTag/${newsCategoryTagId}`
			);
			fetchTags();
			directiontoaster("directionssuccessToast");
		} catch (error) {
			console.error("Something went wrong", error);
			directiontoaster("directionsdangerToast");
		}
	};

	function actionColumnBodyTemplate(newsCategory) {
		return (
			<>
				<Link to={`/EditNewsCategoryTag/:${newsCategory.newsCategoryTagId}`}>
					<i className="candidate-icons" title="Edit News Category Tags">
						<FaRegEdit />
					</i>
				</Link>

				<ModalDelete
					onDelete={() => deleteHandler(newsCategory.newsCategoryTagId)}
					deleteMessage={`Are you sure you would like to delete ${newsCategory.tag}`}
				/>
			</>
		);
	}

	return (
		<Fragment>
			<Breadcrumbs
				parent="News Feeds"
				title="Tags"
				mainTitle="Tag Management"
			/>
			<Container fluid={true}>
				<Col>
					<Card>
						<DataTable
							scrollable
							rowHover
							rowClassName={"mustHaveRow"}
							value={data}
							size={"small"}
							paginator
							rows={25}
							rowsPerPageOptions={[10, 25, 50, 100]}
							filterDisplay={"row"}
							id="badge-table"
						>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="Tag"
								field="tag"
							></Column>
							<Column
								className="candidate-icon-list"
								body={actionColumnBodyTemplate}
								header=""
							></Column>
						</DataTable>
						<Link
							to={`${process.env.PUBLIC_URL}/NewsCategoryTag/AddNewsCategoryTag`}
						>
							<Btn attrBtn={{ color: "primary", id: "tag-badge" }}>
								Add Category Tag
							</Btn>
						</Link>
					</Card>
				</Col>
			</Container>
		</Fragment>
	);
};

export default ViewNewsCategoryTag;
